import { useCallback, useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import { Link, useLocation } from 'react-router-dom'

import { menu, Navigration } from './navbar.navigation'
import { ImageComponent } from 'components/ImageButtonPanel/ImageButtonPanel'
import { ReactComponent as MenuIcon } from 'images/menu.svg'

import './navbar.style.css'

export const Navbar = () => {
  const { pathname } = useLocation()
  const ref = useRef<HTMLDivElement>(null)
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const handleClick = useCallback(() => {
    setIsOpen(!isOpen)
  }, [isOpen])

  useEffect(() => {
    const handleWrapperClick = (event: MouseEvent) => {
      const { target } = event

      if (target instanceof Node && ref.current === target) {
        setIsOpen(false)
      }
    }
    const handleEscapePress = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setIsOpen(false)
      }
    }

    window.addEventListener('click', handleWrapperClick)
    window.addEventListener('keydown', handleEscapePress)

    return () => {
      window.removeEventListener('click', handleWrapperClick)
      window.removeEventListener('keydown', handleEscapePress)
    }
  }, [])

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'

      return
    }

    document.body.style.overflow = 'unset'
  }, [isOpen])

  const renderMenu = menu.map((el: Navigration, index: number) => {
    const classname = classNames('navbar-text', el.classNames, {
      'navbar-text-current-location': pathname.includes(el.target),
      disabled: el.disabled,
    })

    return (
      <li key={index} className={classname} onClick={handleClick}>
        <Link to={el.target}>
          <span>{ImageComponent(el.iconKey)}</span>
          <span>{el.title}</span>
        </Link>
      </li>
    )
  })

  const sidebarClass = classNames('navbar-menu', {
    'navbar-menu-active': isOpen,
  })

  const overlayClass = classNames({
    'navbar-overlay': isOpen,
  })

  return (
    <div>
      <span className="navbar-menu-icon cursor--pointer" onClick={handleClick}>
        <MenuIcon />
      </span>
      <div className={overlayClass} ref={ref}>
        <nav className={sidebarClass}>
          <ul className="navbar-menu-items">
            <li className="navbar-menu-icon navbar-toggle" onClick={handleClick}>
              <Link to="/panel/menu">
                <span>WMS-WEB</span>
              </Link>
            </li>
            {renderMenu}
          </ul>
        </nav>
      </div>
    </div>
  )
}
